import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cropper from "react-cropper";

import { envAwarePost } from "../../util/util";
import { fullBasePath } from "../../util/util";
import { useHistory } from "react-router-dom"
import Spinner from 'react-bootstrap/Spinner'

import useS3DirectUpload from '../../hooks/useS3DirectUpload'
import {
  getProgressPictures,
  getComparisonPictures,
  editProgressPicture,
  deleteProgressPicture,
  deleteComparisonPicture
} from "../pictures/picturesSlice";
import { createProgressPicture } from "./viewPicturesSlice";

import moment from "moment";
import DatePicker from "react-datepicker";
import "cropperjs/dist/cropper.css";

import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import classes from "./ViewPictures.module.css";
import {getAllClients} from '../users/usersSlice.js'
import useApiStatusDispatch from "../../hooks/useApiStatusDispatch";


function formatDate(date) {
  return moment(date).format("MMM DD, YYYY");
}

const ViewPictures = () => {
  const [imageList, setImageList] = useState([]);
  const [listType, setListType] = useState("gallery"); //should be either "gallery" or "comparison";
  const [comparisonImages, setComparisonImages] = useState([]);
  const [picToCompare, setPicToCompare] = useState([]);
	const history = useHistory()
  const statusDispatch = useApiStatusDispatch();
  const dispatch = useDispatch();

	const isTrainer = useSelector(state => state.users.current_user.account_type) === 'trainer'
  const url = new URL(window.location.href);
	const client_id = url.searchParams.get("client");
	useEffect(() => {
		if(isTrainer){
			dispatch(getAllClients())
		}
	},[])
	const clients = useSelector(state => state.users?.clients?.entities)
	const [client, setClient] = useState(undefined)
  useEffect(() => {
		setClient(clients[client_id])
	},[clients, client_id])

  const {
    file:upload,
    processUpload,
    setUpload,
    clearUpload
  } = useS3DirectUpload()

  const [errorModalShow, setErrorModalShow] = useState(false);

  //delete variables
  const [deleteMode,setDeleteMode] = useState(false)
  const [toDelete,setToDelete] = useState([])
  const toggleToDelete = (id)=>{
    if(toDelete.includes(id)){
      setToDelete(p => p.filter(i=>i!==id))
    }else {
      setToDelete( p => [...p,id])
    }
  }

  const handleBulkDelete = ()=>{
    setDeleteMode(false)
    setImageList(p=>p.filter(i=>!toDelete.includes(i.pic_id)))
    envAwarePost('/api/pictures',{
      action:'deleteProgressPictures',
      ids:toDelete
    })
    setToDelete([])
  }

  const handleCancelDeleteMode = ()=>{
    setDeleteMode(false)
    setToDelete([])
  }

  // Edit Modal Variables
  const [showEditModal, setShowEditModal] = useState(false);
  const [editModalImg, setEditModalImg] = useState({});
  const [editModalDate, setEditModalDate] = useState("");
  const [editModalCaption, setEditModalCaption] = useState("");
  const [editModalObj, setEditModalObj] = useState("");
  const handleCloseEditModal = () => setShowEditModal(false);
  const handleShowEditModal = () => {
    setShowEditModal(true);
  };
  // Add Modal Variables
  const [showAddModal, setShowAddModal] = useState(false);
  const [addModalImg, setAddModalImg] = useState("");
  const [addModalDate, setAddModalDate] = useState("");
  const [addModalCaption, setAddModalCaption] = useState("");
  const handleCloseAddModal = () => {
    setShowAddModal(false);
    setAddModalImg("");
    setAddModalDate("");
    setAddModalCaption("");
    addImgRef.current = null;
  };
  const handleShowAddModal = () => {
    setShowAddModal(true);
  };

  // View Image Modal Variables
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewModalImg, setViewModalImg] = useState("");
  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setViewModalImg("");
  };

  //Crop Variables
  const cropperRef = useRef(null);
  const croppedImgRef = useRef(null);
  const onCrop = () => {
    const imageElement = cropperRef?.current;
    const cropper = imageElement?.cropper;
    cropper
      .getCroppedCanvas()
      .toBlob(
        async (blob) => {
          croppedImgRef.current = blob
          setUpload( await new File([blob],`image.jpeg`,{type:"image/jpeg"}))
        }, 
        "image/jpeg"
      );
  };
  const addImgRef = useRef(null);

  // const buttonRef = useRef(null);
  const addBtnRef = useRef(null);

  const user = useSelector((state) => state.users.current_user);
  const pictures = useSelector((state) => state.pictures);
  const newPicId = useSelector((state) => state.photoReel.newPic);
  const [isCropSaveLoading, setIsCropSaveLoading] = useState(false);
  
  const trainerId = useSelector((state) => state.users.current_user.bio_data.trainer_id)
  const picName = (picURL) =>{
    let pic = picURL?.split('/')
    if(pic){
      pic = pic[-1]
    }
    return pic
  }

  const handleCropAndSave = async ()=>{
    if (!addModalDate) {
      alert("Please enter a date");
      return;
    }

    if (!addModalImg) {
      alert("Please select an image");
      return;
    }

    setIsCropSaveLoading(true);

    const s3Res = await processUpload()
    if(s3Res.success){
      const postData = {
        client_id,
        caption: addModalCaption,
        date: addModalDate,
        img:s3Res.payload.url
      }
      statusDispatch(createProgressPicture(postData), "picture", "create")
      .then(res=>{
        setShowAddModal(false);
        setIsCropSaveLoading(false);
      });
    }//end if s3 success
  }//end handle crop and save

  //Comparison Function
  const comparisonFunction = () => {
    if (comparisonImages.length == 1) {
      envAwarePost('api/pictures/', {
        action: "fetchOkayToAddComparisonPicture",
      }).then((res) => {
        if (res.data.ok) {
          setPicToCompare(comparisonImages[0].pic_id);
          // buttonRef.current.textContent = "Selected";
        } else {
          setComparisonImages([]);
          setErrorModalShow(true);
        }
      });
    } else if (comparisonImages.length == 2) {
      envAwarePost('api/pictures/', {
        action: "fetchOkayToAddComparisonPicture",
      }).then((res) => {
        if (res.data.ok) {
          let pic1 = comparisonImages[0];
          let pic2 = comparisonImages[1];
          envAwarePost("api/pictures/", {
            action: "compareProgressPictures",
            pic_id_1:pic1.pic_id,
            pic_id_2:pic2.pic_id
          }).then((res) => {
            if (res.success == "1") {
              if(isTrainer){
                dispatch(getComparisonPictures({client_id}));
              } else {
                dispatch(getComparisonPictures());
              }
              setComparisonImages([]);
              setListType("comparison");
              setPicToCompare("");
            }
          });
        } else {
          setComparisonImages([]);
          setErrorModalShow(true);
        }
      });
    } else {
      return;
    }
  };

  useEffect(() => {
    if (listType == "gallery") {
      setImageList(pictures.pics);
    } else {
      setImageList(pictures.comparisonPics);
    }
  }, [pictures, listType]);

  useEffect(() => {
    comparisonFunction();
  }, [comparisonImages]);

  useEffect(() => {
    const postData = {}
    if(isTrainer) postData.client_id = client_id
    dispatch(getProgressPictures(postData))
    dispatch(getComparisonPictures(postData))
    handleCloseAddModal();
  }, [newPicId]);

  const handleShare = (picURL) =>{
    let pic = picURL.split('/')
    pic = pic[pic.length-1]
    // history.push(`/shared-comparison-photos/?trainer=${trainerId}&pictureName=${pic}`)
    window.location.href =(`https://www.fitsw.com/shared-comparison-photos/?trainer=${trainerId}&pictureName=${pic}`)
  }

  return (
    <div className="pt-2 px-2 px-md-3">
      <div className="d-flex justify-content-between mb-2">
        <strong className="d-block">{isTrainer ? client?.user_name : 'Photos'}</strong>
        <div>
          <ButtonGroup>
            {deleteMode&&
              <Button onClick={handleCancelDeleteMode} variant="outline-dark" size='sm'>
                Cancel
              </Button>
            }
            <Button
              onClick={
                deleteMode
                ? handleBulkDelete
                : setDeleteMode.bind(null,p=>!p)
              }
              variant={deleteMode?"danger":"outline-danger"}
              className="mr-1"
              size="sm"
            >
              {
                deleteMode
                ? 'Delete Selected'
                : 'Bulk Delete'
              }
            </Button>
          </ButtonGroup>

          <Button
            ref={addBtnRef}
            variant="outline-primary"
            size="sm"
            onClick={() => {
              addBtnRef.current.textContent = "Loading";
              envAwarePost("api/pictures/", {
                action: "fetchOkayToAddProgressPicture",
              }).then((res) => {
                addBtnRef.current.textContent = "Add Picture";
                if (res.data.ok) {
                  handleShowAddModal();
                } else {
                  setErrorModalShow(true);
                  return;
                }
              });
            }}
          >
            Add Picture
          </Button>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <Button
          onClick={() => setListType("gallery")}
          className={[
            "shadow-sm",
            classes.ListTypeButton,
            listType == "gallery" && classes.ActiveBtn,
          ].join(" ")}
          size="sm"
        >
          Gallery
        </Button>
        <Button
          onClick={() => setListType("comparison")}
          className={[
            "shadow-sm",
            classes.ListTypeButton,
            listType == "comparison" && classes.ActiveBtn,
          ].join(" ")}
          size="sm"
        >
          Comparison Photos
        </Button>
      </div>
      <div className="d-flex flex-wrap">
        {imageList.map((pic) => (
          <div className="col-xs-12 col-md-6 col-lg-4 mb-5 d-flex flex-column align-items-center">
            <Card
              style={{
                minWidth: "270px",
                minHeight: "350px",
                position: "relative",
                cursor: "pointer",
              }}
            >
              {listType == "gallery" ? (
                <div className={classes.Card}>
                  <Card.Body className={"px-0 py-1"}>
                    <div className={classes.Overlay}>Edit / View</div>
                    <Card.Text>
                      {pic.date && (
                        <div style={{ textAlign: "center" }}>
                          {formatDate(pic.date)}
                        </div>
                      )}
                      {pic.caption ? (
                        <div
                          style={{ textAlign: "center", fontSize: "14px" }}
                        >
                          {pic.caption}
                        </div>
                      ) : (
                        <div style={{ marginBottom: "35px" }}></div>
                      )}
                    </Card.Text>
                    <div className={classes.ImgHolder}>
                      <img
                        src={pic.img}
                        onClick={() => {
                          setEditModalImg(pic.img);
                          setEditModalDate(pic.date);
                          setEditModalCaption(pic.caption);
                          setEditModalObj(pic);
                          setShowEditModal(true);
                        }}
                        className={[
                          "img-fluid rounded",
                          classes.CardImg,
                        ].join(" ")}
                        alt="Progress Image"
                      />
                    </div>
                    {deleteMode&&
                      <div className="text-center">
                        <Form.Check 
                          onChange={toggleToDelete.bind(null,pic.pic_id)}
                          checked={toDelete.includes(pic.pic_id)}
                          id={`delete-pic-${pic.pic_id}`}
                          label="delete"
                        />
                      </div>
                    }
                    {!deleteMode&&
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: 10,
                        }}
                      >
                        <Button
                         className="bg-danger border-danger ml-1"
                          style={{
                            width: "40%",
                          }}
                          onClick={() => {
                            let confirmation = window.confirm(
                              "Are you sure you want to delete this image"
                            );
                            if (confirmation) {
                              statusDispatch(
                                deleteProgressPicture(pic.pic_id), "picture", "delete"
                              );
                            }
                          }}
                        >
                          <i
                            class="fa fa-times"
                            aria-hidden="true"
                            style={{ marginRight: 5 }}
                          ></i>
                          Delete
                        </Button>
                        <Button
                        className="mr-1"
                          style={picToCompare == pic.pic_id ? {
                            width: "50%",
                            color: "#000",
                            backgroundColor: "rgb(104 255 150)",
                            border: "1px solid rgb(104 255 150)"
                          
                        }
                        :
                        {
                         width: "50%",
                          color: "#007bff",
                          backgroundColor: "#fff",
                          border: "1px solid #007bff"
                        }}
                          onClick={(e) => {
                            // buttonRef.current = e.target;
                            if (
                              comparisonImages.length == 0 ||
                              comparisonImages[0].pic_id != pic.pic_id
                            )
                              setComparisonImages([...comparisonImages, pic]);
                              e.currentTarget.blur();
                          }}
                            
                        >
                          <i
                            class="fa fa-clone"
                            aria-hidden="true"
                            style={{ marginRight: 5 }}
                          ></i>
                          {picToCompare == pic.pic_id
                            ? "Selected"
                            : "Compare"}
                        </Button>
                      </div>
                    }
                  </Card.Body>
                </div>
              ) : (
                <div className={classes.Card}>
                <Card.Body>
                  <div className={classes.Overlay}>View</div>
                  <Card.Text>
                    {formatDate(pic.firstDate) != "Invalid date" &&
                      formatDate(pic.secondDate) != "Invalid date" && (
                        <div style={{ textAlign: "center" }}>
                          {formatDate(pic.firstDate)} vs{" "}
                          {formatDate(pic.secondDate)}
                        </div>
                      )}
                    {pic.firstCaption && pic.secondCaption ? (
                      <div
                        style={{ textAlign: "center", fontSize: "14px" }}
                      >
                        {pic.firstCaption} vs {pic.secondCaption}
                      </div>
                    ) : (
                      <div style={{ marginBottom: "35px" }}></div>
                    )}
                  </Card.Text>
                  <div className={classes.ImgHolder}>
                    <img
                      src={pic.comparisonImg}
                      className="img-fluid rounded"
                      alt="Comparison Image"
                      onClick={() => {
                        setViewModalImg(pic.comparisonImg);
                        setShowViewModal(true);
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  >
                    <Button
                     className="bg-danger border-danger"
                      style={{
                        width: "40%",
                      }}
                      onClick={() => {
                        let confirmation = window.confirm(
                          "Are you sure you want to delete this image"
                        );
                        if (confirmation) {
                          statusDispatch(
                            deleteComparisonPicture(pic.comparisonPic_id),"picture","delete"
                          );
                        }
                      }}
                    >
                      <i
                        class="fa fa-times"
                        aria-hidden="true"
                        style={{ marginRight: 5 }}
                      ></i>
                      Delete
                    </Button>
                    <Button
                      style={{
                        width: "40%",
                        color: "#007bff",
                        backgroundColor: "#fff",
                        border: "1px solid #007bff",
                      }}
                      onClick={()=>handleShare(pic.comparisonImg)}
                    >
                      {/* <a
                        href={`./shared-comparison-photos/?trainer=${trainerId}&pictureName=${pic.comparisonImg}`}
                        target="_blank"
                      > */}
                        <i
                          class="fa fa-share"
                          aria-hidden="true"
                          style={{ marginRight: 5 }}
                        ></i>
                        Share
                      {/* </a> */}
                    </Button>
                  </div>
                </Card.Body>
                </div>
              )}
            </Card>
          </div>
        ))}
      </div>
      
      {/*  Account Limit Modal */}
      <Modal show={errorModalShow} onHide={() => setErrorModalShow(false)} >
				<Modal.Header closeButton>
					<Modal.Title>Account Limit</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<p className="mt-2"> Sorry you have reached your account limit. Upgrade your plan to add more photos </p>
				</Modal.Body>

				<Modal.Footer>
					<Button variant="primary" onClick={() => setErrorModalShow(false)}>Close</Button>
				</Modal.Footer>
			</Modal>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={handleCloseEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Picture Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={[classes.FlexRowGroup, "mb-3"].join(" ")}>
            <label htmlFor="date">Date</label>
            <div className="col-sm-9">
              <DatePicker
                type="date"
                dateFormat="MMM dd, yyyy"
                className="form-control"
                selected={Date.parse(moment(editModalDate))}
                onChange={(date) => {
                  setEditModalDate(moment(date).format("YYYY-MM-DD"));
                }}
              />
            </div>
          </div>
          <div className={[classes.FlexRowGroup, "mb-3"].join(" ")}>
            <label htmlFor="caption">Caption</label>
            <div className="col-sm-9">
              <input
                className="form-control"
                id="caption"
                value={editModalCaption}
                onChange={(e) => setEditModalCaption(e.target.value)}
              />
            </div>
          </div>
          <Button
            size="sm"
            style={{
              background: "#007bff",
              border: "1px solid #007bff",
              float: "right",
              marginBottom: 5,
            }}
            onClick={() => {
              statusDispatch(
                editProgressPicture({
                  id: editModalObj.pic_id,
                  update:{
                    date: editModalDate,
                    caption: editModalCaption,
                  }
                }),"picture","update"
              );
              handleCloseEditModal();
            }}
          >
            Update date & caption
          </Button>
          <div>
            <img
              style={{ width: "100%" }}
              src={editModalImg}
            />
          </div>
        </Modal.Body>
      </Modal>

      {/* Add Image Modal */}
      <Modal show={showAddModal} onHide={handleCloseAddModal} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Add</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={[classes.FlexRowGroup, "mb-3"].join(" ")}>
            <label htmlFor="date">Date</label>
            <div className="col-sm-9">
              <DatePicker
                type="date"
                dateFormat="MMM dd, yyyy"
                className="form-control"
                selected={Date.parse(moment(addModalDate))}
                onChange={(date) => {
                  setAddModalDate(moment(date).format("YYYY-MM-DD"));
                }}
              />
            </div>
          </div>
          <div className={[classes.FlexRowGroup, "mb-3"].join(" ")}>
            <label htmlFor="caption">Caption</label>
            <div className="col-sm-9">
              <input
                className="form-control"
                id="caption"
                value={addModalCaption}
                onChange={(e) => setAddModalCaption(e.target.value)}
              />
            </div>
          </div>
          <div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <label
                className="btn btn-sm shadow-sm mt-2"
                style={{ color: "#007bff", border: "1px solid #007bff" }}
              >
                Add Photo
                <input
                  type="file"
                  hidden
                  onChange={(e) => {
                    setAddModalImg(e.target.files[0]);
                    addImgRef.current = URL.createObjectURL(e.target.files[0]);
                  }}
                />
              </label>
            </div>
            {addModalImg && (
              <Cropper
              zoomable={false}
              viewMode={2}
              autoCropArea={1}
                src={addImgRef.current}
                // Cropper.js options
                guides={false}
                crop={onCrop}
                ref={cropperRef}
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
        <Button
            size="sm"
            className="bg-danger border-danger"
            onClick={handleCloseAddModal}
          >
            Cancel
          </Button>
          <Button
            className="bg-primary"
            size="sm"
            onClick={handleCropAndSave}
          >
            {isCropSaveLoading ? <Spinner size="sm" animation="border"/>  : "Crop & Save" }
          </Button>
        </Modal.Footer>
      </Modal>

      {/* View Image Modal */}
      <Modal show={showViewModal} onHide={handleCloseViewModal}>
        <Modal.Header closeButton>
          <Modal.Title>View Comparison Picture</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ marginBottom: "15px" }}>
              To increase the size or adjust zoom, download the image
            </div>
            <a href={viewModalImg} target="_blank">
              <Button style={{ display: "block", marginBottom: "15px" }}>
                Download Image
              </Button>
            </a>
            <img
              src={viewModalImg}
              alt="View Comparison Image"
              style={{ width: "100%" }}
            />
          </div>
            
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ViewPictures;
